<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"  :custom-update-actions="[listMacroEjecutor]"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedSecretariaEjecutora" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    @updateValues="setupUpdateValues"  :custom-update-actions="[listMacroEjecutor]" :custom-update-selected-data="customUpdateSelectedData"
                    :updatePermission="'update_secretarias_ejecutoras'"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedSecretariaEjecutora"
                           :load-data="loadSecretariaEjecutora"
                           :entity="entity" :auth-token="authToken" :list-api="listApi" :queries="queries"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadSecretariaEjecutora"
                 :collection-macro-ejecutor = "collectionMacroEjecutor" 
                 :custom-update-value-data="customUpdateValueData"
                 @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>

import HeaderComponent from "@/layouts/main/HeaderComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import TableComponent from "@/layouts/main/TableComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import {useAuth} from "@/components/auth/store/composables";
import {reactive, ref} from "vue";
import {listCollectionData, useLayoutMain} from "@/layouts/main";
import SecretariasEjecutorasCrearActualizarComponent
  from "@/components/parametros/components/SecretariasEjecutorasCrearActualizarComponent";

export default {
  name: "SecretariasEjecutorasCRUD",
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    SecretariasEjecutorasCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Secretarias Ejecutoras',
      entity: {gender: 'f', value: 'secretaria ejecutora'},
      childFormComponent: 'secretariasEjecutorasCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: "ID",
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre del ejecutor",
        },
        'macroEjecutor.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: " Macro Ejecutor",
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: "Fecha de creación",
        },
      }
    };
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionMacroEjecutor = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedSecretariaEjecutora = ref({
      id: '',
      nombre: '',
      id_macro_ejecutor:'',
      estado: ''
    });
    const loadSecretariaEjecutora = ref({
      nombre: '',
      id_macro_ejecutor:''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_SECRETARIAEJECUTORA_CREATE,
      list: process.env.VUE_APP_NEST_SECRETARIAEJECUTORA_FINDALL,
      update: process.env.VUE_APP_NEST_SECRETARIAEJECUTORA_UPDATE,
      updateState: process.env.VUE_APP_NEST_SECRETARIAEJECUTORA_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      return value;
    };

    const listMacroEjecutor = async () => await listCollectionData(
      process.env.VUE_APP_NEST_MACROEJECUTOR_FINDALL, 
      {'collectionMacroEjecutor': collectionMacroEjecutor}, 
      authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    await listMacroEjecutor();


    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedSecretariaEjecutora, loadSecretariaEjecutora, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedSecretariaEjecutora,
      loadSecretariaEjecutora,
      listApi,
      paginate,
      queries,
      collectionMacroEjecutor,
      setupUpdateValues,
      cleanLoadSelectedData,
      listMacroEjecutor,
      customUpdateValueData,
      console:console,
    };
  }
};
</script>
